import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useBrand } from '../context/BrandContext'
import { colors, radius, s, ui } from '../styles/theme'
import { useIsMobile } from '../hooks/useViewport'
import SmartContentDenetim from './SmartContentDenetim'
import IcerikBloklari from './IcerikBloklari'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000'

const EMPTY = {
  content1: { heading: '', text: '', expert_name: '', expert_text: '' },
  image1: '', pin1: { title: '', text: '' },
  image2: '', pin2: { title: '', text: '' },
  content2: { heading: '', text: '', expert_name: '', expert_text: '' },
  faq: [],
}

function cozEntity(t) {
  return String(t || '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;|&apos;/gi, "'")
}

function htmlToText(ham) {
  const h = String(ham == null ? '' : ham)
  if (!/<[a-zA-Z][^>]*>/.test(h)) return h
  let x = h
  x = x.replace(/<script[\s\S]*?<\/script>/gi, '').replace(/<style[\s\S]*?<\/style>/gi, '')
  x = x.replace(/<h[1-6]\b[^>]*>([\s\S]*?)<\/h[1-6]>/gi, function (m, ic) {
    const d = cozEntity(ic).replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim()
    return d ? '\n## ' + d + '\n' : ''
  })
  x = x.replace(/<(?:strong|b)\b[^>]*>([\s\S]*?)<\/(?:strong|b)>/gi, function (m, ic) {
    const d = cozEntity(ic).replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim()
    return d ? '**' + d + '**' : ''
  })
  x = x.replace(/<li\b[^>]*>/gi, '\n- ').replace(/<\/li>/gi, '\n')
  x = x.replace(/<br\s*\/?>/gi, '\n')
  x = x.replace(/<\/(?:p|div|h1|h2|h3|h4|h5|h6|ul|ol|tr)>/gi, '\n')
  x = x.replace(/<[^>]+>/g, '')
  x = cozEntity(x)
  return x.split('\n')
    .map(function (l) { return l.replace(/[ \t]+/g, ' ').trim() })
    .map(function (l) { return l === '-' ? '' : l })
    .filter(function (l, i, a) {
      if (l !== '') return true
      const o = a.slice(0, i).reverse().find(function (x) { return x !== '' })
      const n = a.slice(i + 1).find(function (x) { return x !== '' })
      if (n && n.charAt(0) === '-') return false
      if (o && o.charAt(0) === '-') return false
      return true
    })
    .filter(function (l, i, a) { return l !== '' || (i > 0 && a[i - 1] !== '') })
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}

function metinleriDuzText(d) {
  const k = Object.assign({}, d)
  const bolum = function (a) {
    return a ? Object.assign({}, a, { text: htmlToText(a.text), heading: htmlToText(a.heading), expert_text: htmlToText(a.expert_text) }) : a
  }
  k.content1 = bolum(k.content1)
  k.content2 = bolum(k.content2)
  if (k.pin1) k.pin1 = Object.assign({}, k.pin1, { text: htmlToText(k.pin1.text), title: htmlToText(k.pin1.title) })
  if (k.pin2) k.pin2 = Object.assign({}, k.pin2, { text: htmlToText(k.pin2.text), title: htmlToText(k.pin2.title) })
  if (Array.isArray(k.faq)) k.faq = k.faq.map(function (f) { return Object.assign({}, f, { question: htmlToText(f.question), answer: htmlToText(f.answer) }) })
  return k
}

function Field({ label, hint, children }) {
  return (
    <div style={{ marginBottom: '14px' }}>
      <label style={s.labelNormal}>{label}</label>
      {children}
      {hint && <p style={{ fontSize: '11.5px', color: colors.textSecondary, margin: '4px 0 0' }}>{hint}</p>}
    </div>
  )
}

export default function SmartContent() {
  const { selectedBrand } = useBrand()
  const mobil = useIsMobile()
  const token = localStorage.getItem('adminToken')
  const headers = { Authorization: token }

  const [mod, setMod] = useState('urun')
  const [q, setQ] = useState('')
  const [results, setResults] = useState([])
  const [searching, setSearching] = useState(false)
  const [product, setProduct] = useState(null)
  const [data, setData] = useState(EMPTY)
  const [lastSent, setLastSent] = useState(null)
  const [hasBackup, setHasBackup] = useState(false)
  const [preview, setPreview] = useState('')
  const [version, setVersion] = useState(1)
  const [tasarimlar, setTasarimlar] = useState([])
  const [busy, setBusy] = useState(false)
  const [msg, setMsg] = useState(null)

  useEffect(() => {
    if (!selectedBrand) { setTasarimlar([]); return }
    axios.get(`${API}/admin/brands/${selectedBrand.id}/smart-content-designs`, { headers })
      .then(res => {
        const l = res.data.designs || []
        setTasarimlar(l)
        setVersion(v => (l.some(t => t.id === v) ? v : (res.data.varsayilan || (l[0] && l[0].id) || 0)))
      })
      .catch(() => setTasarimlar([]))
  }, [selectedBrand?.id]) // eslint-disable-line

  const aktifTasarim = tasarimlar.find(t => t.id === version) || null
  const sssVar = !aktifTasarim || aktifTasarim.sss

  function flash(text, ok = true) { setMsg({ text, ok }); setTimeout(() => setMsg(null), 3500) }

  function search() {
    if (!selectedBrand || !q.trim()) return
    setSearching(true)
    axios.get(`${API}/admin/brands/${selectedBrand.id}/smart-content/products`, { headers, params: { q } })
      .then(res => setResults(res.data.products || []))
      .catch(() => {})
      .finally(() => setSearching(false))
  }

  function pickProduct(p) {
    setProduct(p); setPreview('')
    axios.get(`${API}/admin/brands/${selectedBrand.id}/smart-content/${p.external_id}`, { headers })
      .then(res => {
        setData(metinleriDuzText({ ...EMPTY, ...(res.data.data || {}), content1: { ...EMPTY.content1, ...(res.data.data?.content1 || {}) }, content2: { ...EMPTY.content2, ...(res.data.data?.content2 || {}) }, pin1: { ...EMPTY.pin1, ...(res.data.data?.pin1 || {}) }, pin2: { ...EMPTY.pin2, ...(res.data.data?.pin2 || {}) }, faq: Array.isArray(res.data.data?.faq) ? res.data.data.faq : [] }))
        setLastSent(res.data.last_sent_at); setHasBackup(res.data.has_backup); setVersion(res.data.template_version || 1)
      })
      .catch(() => setData(EMPTY))
  }

  function setC(section, key, value) { setData(d => ({ ...d, [section]: { ...d[section], [key]: value } })) }
  function setV(key, value) { setData(d => ({ ...d, [key]: value })) }
  function setFaq(i, key, value) { setData(d => ({ ...d, faq: (d.faq || []).map((f, j) => j === i ? { ...f, [key]: value } : f) })) }
  function addFaq() { setData(d => ({ ...d, faq: [...(d.faq || []), { question: '', answer: '' }] })) }
  function delFaq(i) { setData(d => ({ ...d, faq: (d.faq || []).filter((_, j) => j !== i) })) }
  function moveFaq(i, yon) {
    setData(d => {
      const a = [...(d.faq || [])]; const j = i + yon
      if (j < 0 || j >= a.length) return d
      const t = a[i]; a[i] = a[j]; a[j] = t
      return { ...d, faq: a }
    })
  }

  function save() {
    setBusy(true)
    axios.put(`${API}/admin/brands/${selectedBrand.id}/smart-content/${product.external_id}`, { data }, { headers })
      .then(() => flash('Kaydedildi'))
      .catch(e => flash(e.response?.data?.error || e.message, false))
      .finally(() => setBusy(false))
  }

  function doPreview(v) {
    const secilen = v || version
    setVersion(secilen)
    setBusy(true)
    axios.post(`${API}/admin/brands/${selectedBrand.id}/smart-content/${product.external_id}/preview`, { data, version: secilen }, { headers })
      .then(res => setPreview(res.data.html || ''))
      .catch(e => flash(e.response?.data?.error || e.message, false))
      .finally(() => setBusy(false))
  }

  function send() {
    if (!window.confirm(`${aktifTasarim ? aktifTasarim.ad + ' tasarımı' : 'İçerik'} ürünün "Açıklama" alanına gönderilecek ve canlıda görünecek. Onaylıyor musunuz?`)) return
    setBusy(true)
    axios.post(`${API}/admin/brands/${selectedBrand.id}/smart-content/${product.external_id}/send`, { data, version }, { headers })
      .then(() => { flash('Açıklama ürüne gönderildi'); setLastSent(new Date().toISOString()); setHasBackup(true) })
      .catch(e => flash(e.response?.data?.error || e.message, false))
      .finally(() => setBusy(false))
  }

  function revert() {
    if (!window.confirm('Ürünün açıklaması Smart Content öncesi orijinal haline döndürülecek. Onaylıyor musunuz?')) return
    setBusy(true)
    axios.post(`${API}/admin/brands/${selectedBrand.id}/smart-content/${product.external_id}/revert`, {}, { headers })
      .then(() => { flash('Orijinal açıklamaya geri alındı'); setLastSent(null) })
      .catch(e => flash(e.response?.data?.error || e.message, false))
      .finally(() => setBusy(false))
  }

  if (!selectedBrand) return <div style={ui.notice}>Önce bir marka seçin.</div>

  const ta = { ...s.input, minHeight: '90px', resize: 'vertical', fontFamily: 'inherit', lineHeight: 1.5 }

  const contentFields = (section) => {
    const c = data[section]
    return (
      <>
        <Field label="Ara başlık"><input style={s.input} value={c.heading} onChange={e => setC(section, 'heading', e.target.value)} placeholder="ör. Bilimin En Kolay Hali" /></Field>
        <Field label="Metin" hint="Her satır ayrı paragraf olur · ara başlık için satır başına «## » · madde için «- » · kalın için **metin**"><textarea style={ta} value={c.text} onChange={e => setC(section, 'text', e.target.value)} placeholder="Açıklama metni…" /></Field>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
          <Field label="Uzman kartı — İsim (opsiyonel)"><input style={s.input} value={c.expert_name} onChange={e => setC(section, 'expert_name', e.target.value)} placeholder="ör. Prof. Dr. …" /></Field>
          <Field label="Uzman kartı — Not (opsiyonel)"><input style={s.input} value={c.expert_text} onChange={e => setC(section, 'expert_text', e.target.value)} /></Field>
        </div>
      </>
    )
  }

  const imageFields = (imgKey, pinKey, variant) => {
    return (
      <div style={{ ...s.cardFlat, padding: '16px' }}>
        <div style={{ fontSize: '13px', fontWeight: 600, marginBottom: '10px' }}>
          Görsel <span style={{ ...ui.chip, marginLeft: '6px' }}>{variant === 'A' ? 'Pin: üzerine gelince kart' : 'Pin: tıklayınca büyük kutu'}</span>
        </div>
        <Field label="Görsel yolu (FTP URL)" hint="Görseli önceden FTP’ye yükleyip tam adresini yapıştırın."><input style={s.input} value={data[imgKey]} onChange={e => setV(imgKey, e.target.value)} placeholder="https://…/gorsel.webp" /></Field>
        <Field label="Pin başlığı"><input style={s.input} value={data[pinKey].title} onChange={e => setC(pinKey, 'title', e.target.value)} placeholder="ör. Dokun Hisset" /></Field>
        <Field label="Pin içeriği (popup metni)"><textarea style={{ ...ta, minHeight: '70px' }} value={data[pinKey].text} onChange={e => setC(pinKey, 'text', e.target.value)} placeholder="Görselin üzerindeki pin’e gelince/tıklayınca çıkacak mesaj." /></Field>
      </div>
    )
  }

  return (
    <div>
      <div style={{ ...s.flexBetween, marginBottom: '18px', flexWrap: 'wrap', gap: '10px' }}>
        <div style={{ minWidth: 0 }}>
          <h1 style={s.pageTitle}>Smart Content</h1>
          <p style={s.pageSubtitle}>Ürün açıklamasını hazır tasarımla oluşturup ürünün “Açıklama” alanına gönderir</p>
        </div>
        <div style={ui.segmented}>
          <button style={ui.segmentedBtn(mod === 'urun')} onClick={() => setMod('urun')}>Ürün</button>
          <button style={ui.segmentedBtn(mod === 'denetim')} onClick={() => setMod('denetim')}>Denetim</button>
          <button style={ui.segmentedBtn(mod === 'blok')} onClick={() => setMod('blok')}>Enjekte İçerikler</button>
        </div>
      </div>

      {mod === 'denetim' && <SmartContentDenetim />}

      {mod === 'blok' && <IcerikBloklari />}

      {mod === 'urun' && (
        <>
      {msg && <div style={{ ...(msg.ok ? s.alertSuccess : s.alertDanger), marginBottom: '16px' }}>{msg.text}</div>}

      <div style={{ ...s.card, marginBottom: '16px' }}>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
          <input style={{ ...s.input, maxWidth: '360px', flex: '1 1 220px', minWidth: 0 }} placeholder="Ürün adı veya kodu ara" value={q}
            onChange={e => setQ(e.target.value)} onKeyDown={e => e.key === 'Enter' && search()} />
          <button style={s.btnSecondary} onClick={search} disabled={searching}>{searching ? 'Aranıyor…' : 'Ara'}</button>
          {product && <span className="sx-break" style={{ fontSize: '13px', color: colors.textSecondary }}>Seçili: <b>{product.name}</b></span>}
        </div>
        {results.length > 0 && !product && (
          <div style={{ marginTop: '12px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
            {results.map(p => (
              <div key={p.external_id} style={{ ...s.cardSm, display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap', cursor: 'pointer' }} onClick={() => pickProduct(p)}>
                {p.image_url && <img src={p.image_url} alt="" style={{ width: '38px', height: '38px', objectFit: 'cover', borderRadius: radius.sm, flexShrink: 0 }} />}
                <div className="sx-break" style={{ flex: '1 1 160px', minWidth: 0 }}>
                  <div style={{ fontSize: '13px', fontWeight: 600 }}>{p.name}</div>
                  <div style={{ fontSize: '11.5px', color: colors.textMuted, fontFamily: 'monospace' }}>{p.product_code}</div>
                </div>
                {p.has_content && <span style={ui.chip}>İçerik var</span>}
                <button style={ui.btnSm}>Seç →</button>
              </div>
            ))}
          </div>
        )}
      </div>

      {product && (
        <>
          <div style={{ ...s.flexBetween, marginBottom: '12px', flexWrap: 'wrap', gap: '8px' }}>
            <div className="sx-break" style={{ fontSize: '13px', color: colors.textSecondary, minWidth: 0 }}>
              {lastSent ? `Son gönderim: ${new Date(lastSent).toLocaleString('tr-TR')}` : 'Henüz gönderilmedi'}
              {product.product_url && <> · <a href={product.product_url} target="_blank" rel="noreferrer" style={{ color: colors.primary }}>Ürünü aç</a></>}
            </div>
            <button style={ui.btnQuiet} onClick={() => { setProduct(null); setResults([]); setPreview('') }}>Başka ürün seç</button>
          </div>

          <div className="sx-grid-panel" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <div style={s.card}>
              <h3 style={s.sectionTitle}>Bölüm 1 — Sol içerik / Sağ görsel</h3>
              {contentFields('content1')}
              <div style={{ height: '10px' }} />
              {imageFields('image1', 'pin1', 'A')}
            </div>
            <div style={s.card}>
              <h3 style={s.sectionTitle}>Bölüm 2 — Sol görsel / Sağ içerik</h3>
              {imageFields('image2', 'pin2', 'B')}
              <div style={{ height: '10px' }} />
              {contentFields('content2')}
            </div>
          </div>

          <div style={{ ...s.card, marginTop: '16px' }}>
            <div style={{ ...s.flexBetween, marginBottom: '10px', flexWrap: 'wrap', gap: '8px' }}>
              <h3 style={{ ...s.sectionTitle, margin: 0 }}>Sıkça Sorulan Sorular</h3>
              <span style={{ fontSize: '11.5px', color: colors.textMuted }}>{sssVar ? 'Seçili tasarımda görünür' : 'Seçili tasarımda görünmez'} · boş sorular yok sayılır</span>
            </div>
            {(data.faq || []).length === 0 && (
              <p style={{ ...ui.emptyText, margin: '0 0 10px' }}>Henüz soru eklenmedi.</p>
            )}
            {(data.faq || []).map((f, i) => (
              <div key={i} style={{ ...s.cardFlat, padding: '14px', marginBottom: '10px' }}>
                <div style={{ ...s.flexBetween, marginBottom: '8px', flexWrap: 'wrap', gap: '8px' }}>
                  <span style={{ fontSize: '12px', fontWeight: 600, color: colors.textSecondary }}>Soru {i + 1}</span>
                  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                    <button style={{ ...ui.btnSm, padding: '4px 9px' }} onClick={() => moveFaq(i, -1)} disabled={i === 0}>↑</button>
                    <button style={{ ...ui.btnSm, padding: '4px 9px' }} onClick={() => moveFaq(i, 1)} disabled={i === (data.faq || []).length - 1}>↓</button>
                    <button style={{ ...ui.btnDangerQuiet, padding: '4px 9px' }} onClick={() => delFaq(i)}>Sil</button>
                  </div>
                </div>
                <Field label="Soru"><input style={s.input} value={f.question || ''} onChange={e => setFaq(i, 'question', e.target.value)} placeholder="ör. Bu kitap hangi yaş grubu için uygun?" /></Field>
                <Field label="Cevap" hint="Her satır ayrı paragraf olur."><textarea style={{ ...ta, minHeight: '70px' }} value={f.answer || ''} onChange={e => setFaq(i, 'answer', e.target.value)} /></Field>
              </div>
            ))}
            <button style={s.btnSecondary} onClick={addFaq}>+ Soru ekle</button>
          </div>

          <div style={{ ...s.card, marginTop: '16px', display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
            <span style={{ fontSize: '13px', color: colors.textSecondary }}>Tasarım:</span>
            {tasarimlar.length > 1 && (
              <div className="sx-wrap" style={{ ...ui.segmented, maxWidth: '100%' }}>
                {tasarimlar.map(t => (
                  <button key={t.id} onClick={() => doPreview(t.id)} disabled={busy}
                    style={ui.segmentedBtn(version === t.id)}>
                    {t.ad}{t.sss ? ' (SSS’li)' : ''}
                  </button>
                ))}
              </div>
            )}
            {tasarimlar.length === 1 && (
              <span style={ui.chipStrong}>{tasarimlar[0].ad}{tasarimlar[0].sss ? ' (SSS’li)' : ''}</span>
            )}
            {tasarimlar.length === 0 && (
              <span style={{ ...ui.notice, flex: '1 1 260px' }}>
                Bu markaya özel bir Smart Content tasarımı tanımlanmamış; gönderim yapılamaz.
              </span>
            )}
            <button style={s.btnSecondary} onClick={() => doPreview()} disabled={busy || !tasarimlar.length}>Önizle</button>
            <button style={s.btnSecondary} onClick={save} disabled={busy}>Kaydet</button>
            <div className="sx-wrap" style={{ marginLeft: 'auto', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              {hasBackup && <button style={ui.btnDangerQuiet} onClick={revert} disabled={busy}>Orijinale geri al</button>}
              <button style={s.btnPrimary} onClick={send} disabled={busy || !tasarimlar.length}>
                {aktifTasarim ? aktifTasarim.ad + ' ile Gönder' : 'Gönder'}
              </button>
            </div>
          </div>

          {preview && (
            <div style={{ ...s.card, marginTop: '16px' }}>
              <h3 style={{ ...s.sectionTitle, marginBottom: '12px' }}>Önizleme — {aktifTasarim ? aktifTasarim.ad : 'Tasarım'}{sssVar ? ' (Sıkça Sorulan Sorular dahil)' : ''}</h3>
              <div className="sx-scroll-x">
                <iframe title="Smart Content Önizleme" srcDoc={`<!doctype html><html><head><meta charset="utf-8"><link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700;800&display=swap" rel="stylesheet"><style>body{margin:0;padding:24px;background:#fff}</style></head><body>${preview}</body></html>`}
                  style={{ display: 'block', width: '100%', minWidth: mobil ? '320px' : undefined, height: mobil ? '480px' : '720px', border: `1px solid ${colors.border}`, borderRadius: radius.md, background: colors.bgCard }} />
              </div>
            </div>
          )}
        </>
      )}
        </>
      )}
    </div>
  )
}
